import { styled } from 'linaria/lib/react';
import React from 'react';
import { theme } from '@mtsbank/ui-kit';
type TabButtonProps = {
  title: string;
  onClick: () => void;
  activeTab?: string;
  main?: boolean;
  icon?: React.ReactElement;
  id?: string;
};
export const TabButton: React.FC<TabButtonProps> = ({
  title,
  onClick,
  activeTab,
  main,
  icon,
  id
}) => <TabButtonWrapper id={id} activeTab={activeTab} title={title} onClick={onClick} main={main} type="button">
    <div className="icon">{icon}</div>
    <Text activeTab={activeTab} title={title}>
      {title}
    </Text>
  </TabButtonWrapper>;
const Text = /*#__PURE__*/styled("div")({
  name: "Text",
  class: "t1cr6xp2"
});
const TabButtonWrapper = /*#__PURE__*/styled("button")({
  name: "TabButtonWrapper",
  class: "twjwntj",
  vars: {
    "twjwntj-0": [props => props.main ? '12px' : '16px'],
    "twjwntj-1": [({
      activeTab,
      title
    }) => activeTab === title ? '#EA1F49' : '#181b36'],
    "twjwntj-3": [({
      activeTab,
      title
    }) => activeTab === title ? '#FAFAFA' : '#888BAA'],
    "twjwntj-6": [props => props.main ? '12px 16px' : '8px 12px'],
    "twjwntj-9": [({
      activeTab,
      title
    }) => activeTab === title ? '#FAFAFA' : '#747796']
  }
});

require("./TabButton.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./TabButton.tsx");